import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import "./style.css";

// Sample usage with dummy data for demonstration.
// You can replace `cardsData` with props or real data as needed.
const cardsData = [
  {
    title: "Referral Income",
    data: [
      { label: "Bonus A", value: 1000 },
      { label: "Bonus B", value: 500 },
      { label: "Bonus C", value: 250 },
    ],
  },
  {
    title: "Monthly Commission",
    data: [
      { label: "Commission A", value: 1200 },
      { label: "Commission B", value: 800 },
    ],
  },
];

const detailedData = [
  { id: 1, label: "Label 1", value: 300 },
  { id: 2, label: "Label 2", value: 400 },
  { id: 3, label: "Label 3", value: 500 },
];

const Card = ({ title, data }) => {
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);

  return (
    <div className="card">
      <h3>{title}</h3>
      <p>
        <strong>Total:</strong>
        <span className="value">{total.toLocaleString()}</span>
      </p>
      {data.map((item, index) => (
        <p key={index}>
          <strong>{item.label}:</strong>
          <span className="value">{Number(item.value).toLocaleString()}</span>
        </p>
      ))}
    </div>
  );
};

const Income = () => {

    const [tab, setTab] = useState(0);

    const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box sx ={{mb:10}}>
      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleTabChange}
        centered
        sx={{ mt: 1 ,mb: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}
      >
        <Tab label="Summary" />
        <Tab label="Details" />
      </Tabs>

      {/* Tab Content */}
      {tab === 0 && (
        <div className="card-container">
          {cardsData.map((card, index) => (
            <Card key={index} title={card.title} data={card.data} />
          ))}
        </div>
      )}

      {tab === 1 && (
        <Box className="card-container">
          <div className="card">
            <h3>Detailed Income</h3>
            {detailedData.map((item) => (
              <p key={item.id}>
                <strong>{item.label}:</strong>{" "}
                <span className="value">{Number(item.value).toLocaleString()}</span>
              </p>
            ))}
          </div>
        </Box>
      )}
    </Box>
  );
};

export default Income;
